/* Hey Hottie — the chat bubble
 *
 * A scripted thread that behaves like a text conversation: bubbles arrive one
 * at a time behind a typing pause, the shopper taps a reply, the thread moves
 * on. Everything it says was typed by a person in the theme editor.
 *
 * The pauses are the whole illusion, and they are also the honest part: a real
 * person takes a beat to answer. But the header says whose words these are, so
 * nobody is being told a human is on the other end.
 */
(function () {
  'use strict';

  function root() {
    return ((window.Shopify && window.Shopify.routes) || {}).root || '/';
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* A single line break inside one bubble is a line break, not a new text.
     An address wants to keep its shape. */
  function withBreaks(s) {
    return esc(s).replace(/\n/g, '<br>');
  }

  /* One step's copy can hold several bubbles. A blank line splits them, the
     way somebody sends three short texts instead of one long one. */
  function bubblesOf(text) {
    return String(text || '')
      .split(/\n\s*\n/)
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function Chat(el) {
    this.el = el;
    this.design = el.getAttribute('data-design-mode') === '1';

    var tag = el.querySelector('[data-hh-chat-script]');
    try {
      this.data = JSON.parse(tag.textContent);
    } catch (e) {
      console.warn('[hey hottie] chat script would not parse:', e);
      return;
    }

    this.byKey = {};
    var list = this.data.steps || [];
    for (var i = 0; i < list.length; i++) {
      var k = (list[i].key || '').trim();
      if (k) this.byKey[k] = list[i];
    }
    this.first = list[0];

    this.panel = el.querySelector('[data-hh-chat-panel]');
    this.thread = el.querySelector('[data-hh-chat-thread]');
    this.replies = el.querySelector('[data-hh-chat-replies]');
    this.tab = el.querySelector('[data-hh-chat-open]');
    this.ship = el.querySelector('[data-hh-chat-ship]');

    this.timers = [];
    this.open = false;
    this.started = false;

    this.wire();

    /* Popping open by itself is a per-visit thing, not a per-page thing.
       Somebody who closed it on the homepage should not meet it again on
       every product page. */
    /* Only opens itself if the merchant asked it to, and then only once a
       visit. Left at 0 it waits to be tapped, which is how it ships. */
    var after = parseInt(el.getAttribute('data-open-after'), 10) || 0;
    if (after > 0 && !this.design && !this.dismissed()) {
      var self = this;
      this.timers.push(setTimeout(function () {
        self.show();
        self.remember();
      }, after * 1000));
    }

    if (this.design) this.show();
  }

  Chat.prototype.dismissed = function () {
    try { return sessionStorage.getItem('hh-chat-dismissed') === '1'; } catch (e) { return false; }
  };
  Chat.prototype.remember = function () {
    try { sessionStorage.setItem('hh-chat-dismissed', '1'); } catch (e) {}
  };

  Chat.prototype.wire = function () {
    var self = this;

    this.tab.addEventListener('click', function () {
      self.open ? self.hide() : self.show();
    });

    /* Exit closes the panel back down to the bubble. The bubble stays put so
       it can be opened again — it never opens itself, so it is only ever on
       screen because somebody asked for it. */
    var x = this.el.querySelector('[data-hh-chat-close]');
    if (x) x.addEventListener('click', function (e) { e.stopPropagation(); self.hide(); });

    var again = this.el.querySelector('[data-hh-chat-restart]');
    if (again) again.addEventListener('click', function () { self.restart(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.open) { self.hide(); }
    });

    document.addEventListener('hh:cart-changed', function () { self.paintShip(); });

    /* Tapping outside closes the panel — but "outside" has to be judged from
       where the click STARTED, not from where the element is by the time this
       runs.

       Tapping a reply clears the reply row, so the button that was tapped is
       gone from the document before this listener fires. el.contains() then
       says false, and the chat closed itself every time somebody answered a
       question. composedPath() is captured when the event is dispatched, so it
       still holds the chat even after the button is detached. */
    document.addEventListener('click', function (e) {
      if (!self.open) return;

      var path = typeof e.composedPath === 'function' ? e.composedPath() : null;
      if (path && path.indexOf(self.el) !== -1) return;

      /* No composedPath (old Safari): if the target is no longer in the
         document, it was almost certainly something of ours that we just
         removed — leave the panel alone rather than guess. */
      var t = e.target;
      if (!path && t && t.nodeType === 1 && !document.documentElement.contains(t)) return;

      if (self.el.contains(t)) return;
      self.hide();
    });

    var ask = this.el.querySelector('[data-hh-chat-ask]');
    var send = this.el.querySelector('[data-hh-chat-asksend]');
    if (ask) {
      this.indexSteps();
      var fire = function () {
        var q = (ask.value || '').trim();
        if (!q) return;
        ask.value = '';
        self.clearTimers();
        self.ask(q);
      };
      if (send) send.addEventListener('click', fire);
      ask.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); fire(); }
      });
    }
  };

  Chat.prototype.show = function () {
    this.open = true;
    this.panel.hidden = false;
    this.el.classList.add('hh-chat--open');
    this.tab.setAttribute('aria-expanded', 'true');
    if (!this.started) {
      this.started = true;
      this.restart();
    }
    this.paintShip();
  };

  Chat.prototype.hide = function () {
    this.open = false;
    this.panel.hidden = true;
    this.el.classList.remove('hh-chat--open');
    this.tab.setAttribute('aria-expanded', 'false');
  };

  Chat.prototype.clearTimers = function () {
    for (var i = 0; i < this.timers.length; i++) clearTimeout(this.timers[i]);
    this.timers = [];
  };

  Chat.prototype.restart = function () {
    this.clearTimers();
    this.thread.innerHTML = '';
    this.replies.innerHTML = '';
    if (this.first) this.say(this.first);
  };

  Chat.prototype.scroll = function () {
    this.thread.scrollTop = this.thread.scrollHeight;
  };

  /* ── free shipping ────────────────────────────────────────────────────────
     Only ever shown once there is something in the bag. "You are $12 away"
     is a nudge; "you are $75 away" on an empty cart is just a price tag. */

  Chat.prototype.paintShip = function () {
    if (!this.ship || !this.data.freeShip) return;
    var self = this;
    var goal = this.data.freeShip;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) { self.ship.hidden = true; return; }

        var left = goal - cart.total_price;
        var txt = self.ship.querySelector('[data-hh-chat-shiptext]');
        var fill = self.ship.querySelector('[data-hh-chat-shipfill]');
        var copy = self.data.copy || {};

        if (left <= 0) {
          txt.textContent = copy.shipDone || '';
          fill.style.width = '100%';
          self.ship.classList.add('hh-chat__ship--done');
        } else {
          txt.textContent = (copy.ship || '').replace('[amount]', money(left));
          fill.style.width = Math.min(100, (cart.total_price / goal) * 100) + '%';
          self.ship.classList.remove('hh-chat__ship--done');
        }
        self.ship.hidden = false;
      })
      .catch(function () { /* no cart, no bar */ });
  };

  /* ── them ─────────────────────────────────────────────────────────────── */

  Chat.prototype.say = function (step) {
    var self = this;
    var lines = bubblesOf(step.text);
    var pause = this.data.typing || 0;

    this.replies.innerHTML = '';

    var i = 0;
    function next() {
      if (i >= lines.length) return self.land(step);

      var line = lines[i++];
      var dots = document.createElement('div');
      dots.className = 'hh-msg hh-msg--them hh-msg--typing';
      dots.innerHTML = '<span class="hh-chat__avatar hh-chat__avatar--' + esc(step.who || 'addi') + '"></span>' +
        '<span class="hh-bubble"><i></i><i></i><i></i></span>';
      self.thread.appendChild(dots);
      self.scroll();

      self.timers.push(setTimeout(function () {
        dots.classList.remove('hh-msg--typing');
        dots.querySelector('.hh-bubble').innerHTML = withBreaks(line);
        self.scroll();
        self.timers.push(setTimeout(next, Math.max(100, pause / 2)));
      }, pause || 1));
    }

    next();
  };

  /* Whatever this step ends with — products, a button, an email field, more
     replies. */
  /* ── a voice note ──────────────────────────────────────────────────────
     Dormant until somebody pastes a clip URL into the step. Tap to play —
     never autoplay, which mobile blocks anyway and which nobody wants from a
     shop. The text is always above it, so the answer still works with the
     sound off, which is how most of a phone audience reads. */

  var playing = null;

  function mmss(n) {
    if (!isFinite(n) || n < 0) n = 0;
    var m = Math.floor(n / 60), s = Math.floor(n % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  Chat.prototype.voice = function (step) {
    var self = this;
    var src = (step.audio || '').trim();
    if (!src) return;

    /* Voice notes are Addi's only — Lacey's steps still get an Addi clip if one
       is set, and the avatar matches the voice rather than the step. */
    var who = (step.audioWho || '').trim() || 'Addi';

    var wrap = document.createElement('div');
    wrap.className = 'hh-msg hh-msg--them';
    wrap.innerHTML =
      '<span class="hh-chat__avatar hh-chat__avatar--addi"></span>' +
      '<span class="hh-bubble hh-vn">' +
        '<button type="button" class="hh-vn__go" aria-label="Play voice note from ' + esc(who) + '">' +
          '<span class="hh-vn__ico"></span></button>' +
        '<span class="hh-vn__mid">' +
          '<span class="hh-vn__who">' + esc(who) + '</span>' +
          '<span class="hh-vn__track"><i></i></span>' +
        '</span>' +
        '<span class="hh-vn__t">0:00</span>' +
      '</span>';
    this.thread.appendChild(wrap);
    this.scroll();

    var go   = wrap.querySelector('.hh-vn__go');
    var fill = wrap.querySelector('.hh-vn__track i');
    var time = wrap.querySelector('.hh-vn__t');
    var au   = null;

    function reset() {
      wrap.classList.remove('hh-vn--on');
      go.setAttribute('aria-label', 'Play voice note from ' + who);
      fill.style.width = '0%';
      if (au) time.textContent = mmss(au.duration);
    }

    go.addEventListener('click', function () {
      if (playing && playing.au !== au) playing.reset(), playing.au.pause();

      if (!au) {
        au = new Audio(src);
        au.preload = 'metadata';
        au.addEventListener('loadedmetadata', function () { time.textContent = mmss(au.duration); });
        au.addEventListener('timeupdate', function () {
          if (au.duration) fill.style.width = (au.currentTime / au.duration) * 100 + '%';
          time.textContent = mmss(au.duration - au.currentTime);
        });
        au.addEventListener('ended', function () { au.currentTime = 0; reset(); playing = null; });
        au.addEventListener('error', function () {
          wrap.classList.add('hh-vn--dead');
          time.textContent = '';
          go.disabled = true;
          go.setAttribute('aria-label', 'This voice note would not play');
        });
      }

      if (au.paused) {
        au.play().then(function () {
          wrap.classList.add('hh-vn--on');
          go.setAttribute('aria-label', 'Pause voice note from ' + who);
          playing = { au: au, reset: reset };
        }).catch(function () { /* blocked, leave it be */ });
      } else {
        au.pause();
        reset();
        playing = null;
      }
    });
  };

  Chat.prototype.land = function (step) {
    var self = this;

    this.voice(step);

    var prods = step.products || [];
    for (var i = 0; i < prods.length; i++) this.card(prods[i], prods.length > 1);

    if (step.capture) this.emailField(step.captureMode === 'message');

    if (step.link) {
      var a = document.createElement('a');
      a.className = 'hh-chat__link';
      a.href = step.link.url;
      a.textContent = step.link.label;
      this.thread.appendChild(a);
    }

    this.scroll();

    var reps = (step.replies || []).filter(function (r) { return r && r.label; });
    if (!reps.length) return;

    reps.forEach(function (r) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hh-chat__reply';
      b.textContent = r.label;
      b.addEventListener('click', function () { self.answer(r); });
      self.replies.appendChild(b);
    });
  };

  Chat.prototype.answer = function (reply) {
    this.replies.innerHTML = '';

    var mine = document.createElement('div');
    mine.className = 'hh-msg hh-msg--me';
    mine.innerHTML = '<span class="hh-bubble">' + esc(reply.label) + '</span>';
    this.thread.appendChild(mine);
    this.scroll();

    var target = reply.next && this.byKey[reply.next.trim()];
    if (target) return this.say(target);

    if (this.design && reply.next) {
      var warn = document.createElement('div');
      warn.className = 'hh-chat__warn';
      warn.textContent = 'Only you can see this: no step has the key "' + reply.next + '".';
      this.thread.appendChild(warn);
      this.scroll();
    }
  };

  /* ── the product card ─────────────────────────────────────────────────── */

  Chat.prototype.card = function (p, tight) {
    var self = this;
    var copy = this.data.copy || {};

    var wrap = document.createElement('div');
    wrap.className = 'hh-msg hh-msg--them hh-msg--card' + (tight ? ' hh-msg--shelf' : '');

    var html = '<span class="hh-chat__avatar" aria-hidden="true"></span>' +
      '<div class="hh-chat__card">' +
      (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="52" height="52">' : '') +
      '<div class="hh-chat__cardin">' +
      '<a class="hh-chat__cardnm" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      (p.note ? '<span class="hh-chat__cardnote">' + esc(p.note) + '</span>' : '') +
      '<span class="hh-chat__cardpr">' + esc(p.price) + '</span>';

    /* One time vs auto-ship. Only offered when a selling plan actually exists
       on the variant — a saving the theme cannot deliver is not a saving. */
    if (p.available && p.plan) {
      html += '<div class="hh-chat__opts" role="group">' +
        '<button type="button" class="hh-chat__opt hh-chat__opt--on" data-plan="">' +
          esc(copy.once || 'one time') + ' <b>' + esc(p.price) + '</b></button>' +
        '<button type="button" class="hh-chat__opt" data-plan="' + esc(p.plan.id) + '">' +
          esc(copy.auto || 'auto-ship & save') + ' <b>' + esc(p.plan.price) + '</b></button>' +
        '</div>';

      /* The terms sit with the choice, not three clicks away in a policy. If a
         plan ever carries a minimum commitment, this is the line that has to
         say so — before they pick it, not when they try to cancel. */
      if (copy.planTerms) {
        html += '<span class="hh-chat__terms">' + esc(copy.planTerms) + '</span>';
      }
    }

    html += '<div class="hh-chat__cardbtns">';
    if (p.available) {
      html += '<button type="button" class="hh-chat__add" data-v="' + esc(p.variant) + '">' +
        esc(copy.add || 'add to bag') + '</button>';
    } else {
      html += '<button type="button" class="hh-chat__add" disabled>' + esc(copy.soldout || 'sold out') + '</button>';
    }
    html += '<a class="hh-chat__see" href="' + esc(p.url) + '">' + esc(copy.view || 'see it') + '</a>' +
      '</div></div></div>';

    wrap.innerHTML = html;
    this.thread.appendChild(wrap);

    var opts = wrap.querySelectorAll('[data-plan]');
    for (var i = 0; i < opts.length; i++) {
      opts[i].addEventListener('click', function () {
        for (var j = 0; j < opts.length; j++) opts[j].classList.toggle('hh-chat__opt--on', opts[j] === this);
      });
    }

    var add = wrap.querySelector('.hh-chat__add:not([disabled])');
    if (!add) return;

    add.addEventListener('click', function () {
      add.disabled = true;
      var body = { id: p.variant, quantity: 1 };
      var chosen = wrap.querySelector('.hh-chat__opt--on[data-plan]');
      if (chosen && chosen.getAttribute('data-plan')) body.selling_plan = chosen.getAttribute('data-plan');

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (d) {
            if (!res.ok) throw new Error(d.description || d.message || 'no');
            return d;
          });
        })
        .then(function () {
          /* Deliberately no page reload — that would throw away the
             conversation they are in the middle of. */
          add.textContent = (self.data.copy || {}).added || 'in your bag ✓';
          add.classList.add('hh-chat__add--done');
          document.dispatchEvent(new CustomEvent('hh:cart-changed'));
          self.paintShip();
        })
        .catch(function (e) {
          add.disabled = false;
          add.textContent = 'try again';
          console.warn('[hey hottie] chat add failed:', e);
        });
    });
  };

  /* ── the email field ──────────────────────────────────────────────────────
     Posts to Shopify's own customer form, so the address lands in Customers
     with an "accepts marketing" flag and flows into whatever sends the email.
     No third party, no extra list to keep in sync. */

  Chat.prototype.emailField = function (isMessage) {
    var self = this;
    var copy = this.data.copy || {};

    var row = document.createElement('div');
    row.className = 'hh-chat__capture' + (isMessage ? ' hh-chat__capture--msg' : '');
    row.innerHTML =
      '<input type="email" class="hh-chat__email" autocomplete="email" inputmode="email" ' +
        'placeholder="' + esc(copy.capturePlaceholder || 'your email') + '" ' +
        'aria-label="' + esc(copy.capturePlaceholder || 'your email') + '">' +
      (isMessage
        ? '<textarea class="hh-chat__msg" rows="2" placeholder="' +
            esc(copy.captureMsgPlaceholder || '') + '" aria-label="' +
            esc(copy.captureMsgPlaceholder || '') + '"></textarea>'
        : '') +
      '<button type="button" class="hh-chat__send">' + esc(copy.captureButton || 'send it') + '</button>';
    this.thread.appendChild(row);

    var input = row.querySelector('.hh-chat__email');
    var msg = row.querySelector('.hh-chat__msg');
    var btn = row.querySelector('.hh-chat__send');

    function done(msg, ok) {
      var note = document.createElement('div');
      note.className = 'hh-chat__capnote' + (ok ? '' : ' hh-chat__capnote--bad');
      note.textContent = msg;
      row.replaceWith(note);
      self.scroll();
    }

    function send() {
      var val = (input.value || '').trim();
      if (!val || val.indexOf('@') < 1) {
        input.focus();
        row.classList.add('hh-chat__capture--bad');
        return;
      }
      row.classList.remove('hh-chat__capture--bad');
      btn.disabled = true;

      var body = new FormData();
      body.append('utf8', '✓');
      body.append('contact[email]', val);

      if (isMessage) {
        /* form_type "contact" is the one Shopify actually emails to the
           customer service address — "customer" only adds a subscriber. */
        body.append('form_type', 'contact');
        body.append('contact[body]', (msg && msg.value.trim()) || 'Sent from the chat on the website.');
      } else {
        body.append('form_type', 'customer');
        body.append('contact[tags]', 'chat');
      }

      fetch(root() + 'contact', { method: 'POST', body: body })
        .then(function (res) {
          if (!res.ok) throw new Error('http ' + res.status);
          done((isMessage ? copy.captureMsgDone : copy.captureDone) || "you're in", true);
        })
        .catch(function () {
          done(copy.captureError || 'that did not go through', false);
        });
    }

    btn.addEventListener('click', send);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); send(); }
    });
  };


  /* ══════════════════════════════════════════════════════════════════════
     Typing a question

     This matches, it does not generate. Everything it can say is still one of
     the steps somebody wrote, or a real product out of the catalogue. When
     neither fits it says so and hands them to a person — which is the whole
     reason it can be trusted on a store selling things people put on their
     skin.
     ══════════════════════════════════════════════════════════════════════ */

  var STOP = ' a an and are as at be but by can do does for from get got has have how i in is it its me my of on or our so that the their them then there these they this to too us was we what when where which who why will with you your '.split(' ');

  function words(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .split(/\s+/)
      .filter(function (w) { return w.length > 2 && STOP.indexOf(w) === -1; });
  }

  /* Two bags per step. The keywords a person wrote are strong evidence; the
     step's own prose is weak evidence, because half the words in it are shared
     with every other step. Keeping them apart is what stops "do you ship to
     canada" landing on a tanning gel. */
  Chat.prototype.indexSteps = function () {
    var list = this.data.steps || [];
    this.index = list.map(function (st) {
      var prose = st.text + ' ' + st.key;
      (st.replies || []).forEach(function (r) { prose += ' ' + r.label; });
      (st.products || []).forEach(function (p) { prose += ' ' + p.title + ' ' + (p.note || ''); });

      var weak = {};
      words(prose).forEach(function (w) { weak[w] = true; });

      /* Keywords are matched as written, so a merchant can put a whole phrase
         like "where is my order" in and have it count as one strong hit. */
      var phrases = String(st.keywords || '')
        .toLowerCase().split(',')
        .map(function (x) { return x.trim(); })
        .filter(Boolean);

      return { step: st, weak: weak, phrases: phrases };
    });
  };

  Chat.prototype.bestStep = function (q) {
    var raw = String(q || '').toLowerCase();
    var terms = words(q);
    if (!terms.length) return null;

    var best = null, bestScore = 0;

    for (var i = 0; i < this.index.length; i++) {
      var row = this.index[i];
      var strong = 0, weak = 0;

      for (var p = 0; p < row.phrases.length; p++) {
        var ph = row.phrases[p];
        if (ph.indexOf(' ') > -1) {
          if (raw.indexOf(ph) > -1) strong += 2;      /* a whole phrase landed */
        } else if (terms.indexOf(ph) > -1) {
          strong += 1;
        }
      }

      for (var j = 0; j < terms.length; j++) {
        if (row.weak[terms[j]]) weak += 1;
      }

      /* Prose alone can never carry a match on its own — it tops out below the
         threshold no matter how many words happen to coincide. */
      var score = strong + Math.min(weak / terms.length, 1) * 0.8;
      if (score > bestScore) { bestScore = score; best = row.step; }
    }

    /* One real keyword hit clears this. Coincidental prose overlap does not. */
    return bestScore >= 1 ? best : null;
  };

  Chat.prototype.searchProducts = function (q) {
    var url = root() + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (((d.resources || {}).results || {}).products) || [];
        return items.map(function (p) {
          var v = (p.variants && p.variants[0]) || {};
          return {
            title: p.title,
            note: '',
            url: p.url,
            price: p.price || '',
            image: p.featured_image ? p.featured_image.url : '',
            variant: v.id ? String(v.id) : '',
            available: p.available !== false,
            plan: null
          };
        }).filter(function (p) { return p.variant; });
      })
      .catch(function () { return []; });
  };

  Chat.prototype.ask = function (q) {
    var self = this;
    var copy = this.data.copy || {};

    this.replies.innerHTML = '';

    var mine = document.createElement('div');
    mine.className = 'hh-msg hh-msg--me';
    mine.innerHTML = '<span class="hh-bubble">' + esc(q) + '</span>';
    this.thread.appendChild(mine);
    this.scroll();

    var step = this.bestStep(q);
    if (step) return this.say(step);

    /* Nothing they wrote matches an answer — try the catalogue, since half of
       what people type is just a product name. */
    this.searchProducts(q).then(function (prods) {
      if (prods.length) {
        return self.say({
          who: 'addi',
          text: copy.askProducts || '',
          products: prods,
          replies: [{ label: 'something else', next: 'start' }]
        });
      }
      self.say({
        who: 'both',
        text: copy.askNoMatch || '',
        capture: true,
        captureMode: 'message',
        replies: [{ label: 'back to the start', next: 'start' }]
      });
    });
  };

  /* ── boot ─────────────────────────────────────────────────────────────── */

  function init() {
    var nodes = document.querySelectorAll('[data-hh-chat]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__hhChat) continue;
      nodes[i].__hhChat = true;
      new Chat(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var n = e.target.querySelector ? e.target.querySelector('[data-hh-chat]') : null;
    if (n) { n.__hhChat = false; init(); }
  });
})();
